/**
 * 为什么要types文件?
 * 1. 一目了然整个app所有的mutation
 * 2. 某些linter插件起作用
 * 3. 装逼
 */


//全局
export const COMP_CITIES = 'COMP_CITIES'; //城市数据
export const COMP_INDUSTRIES = 'COMP_INDUSTRIES'; //行业数据
export const POST_LOADING = 'POST_LOADING'; //POST请求loading
export const COMP_USERINFO = 'COMP_USERINFO'; //用户信息
export const WX_SHARE = 'WX_SHARE'; //微信分享
export const SHOW_APP = 'SHOW_APP'; //判断显示app  如wx.ready后再显示

//登录
export const APP_LOGIN = 'APP_LOGIN'; //是否登录
